import React from 'react';
import './Tag.css';

/**
 * Small glass pill for skills and tech stacks.
 *
 * @param {'violet' | 'cyan' | 'pink'} accent
 * @param {'sm' | 'md'} size
 */
export default function Tag({ children, accent = 'cyan', size = 'md' }) {
  return <span className={`tag tag--${accent} tag--${size}`}>{children}</span>;
}
